<template lang="pug">
.production-tool-contracting
	.form-row(v-if="loading")
		VuePlaceholder(type="form")
	template(v-else)
		ProductionToolContractingForm(v-if="resultState == RESULTSTATES.FORM", ref="form", :yearly-income="yearlyIncome", :instrument="instrument", :captcha-img="captcha.htmlFragment", :captcha-error="captchaError", :settlements="settlements", @zip-change="getSettlements", @captcha-keyup="resetCaptchaError", :sending="sending", @submit="send")
		ProductionToolContractingSuccess(v-if="resultState == RESULTSTATES.SUCCESS")
		ProductionToolContractingError(v-if="resultState == RESULTSTATES.ERROR", :public-error-message="publicErrorMessage")
</template>

<script>
import ProductionToolContractingForm from './production-tool-contracting-form/production-tool-contracting-form';
import ProductionToolContractingSuccess from './production-tool-contracting-success/production-tool-contracting-success';
import ProductionToolContractingError from './production-tool-contracting-error/production-tool-contracting-error';
import postcodesApi from '../../api/postcodes-api';
import productionToolContractingApi from '../../api/production-tool-contracting-api';
import VuePlaceholder from '@ui-common/vue-placeholder';
const RESULTSTATES = {
	FORM: 'FORM',
	SUCCESS: 'SUCCESS',
	ERROR: 'ERROR'
};

export default {
	data: () => ({
		sending: false,
		loading: true,
		settlements: null,
		yearlyIncome: null,
		instrument: null,
		captcha: {
			captchaKey: null,
			htmlFragment: null
		},
		captchaError: false,
		resultState: RESULTSTATES.FORM,
		publicErrorMessage: null
	}),
	components: {
		ProductionToolContractingForm,
		ProductionToolContractingSuccess,
		ProductionToolContractingError,
		VuePlaceholder
	},
	computed: {
		RESULTSTATES() {
			return RESULTSTATES;
		}
	},
	methods: {
		resetCaptchaError() {
			this.captchaError = false;
		},
		async send(data) {
			try {
				this.sending = true;
				this.captchaError = false;
				const dataToSend = Object.assign({}, data, { captchaKey: this.captcha.captchaKey });
				await productionToolContractingApi.submit(dataToSend);
				this.resultState = RESULTSTATES.SUCCESS;
			} catch (err) {
				if (err.response.status == 400) {
					if (err.response.data && err.response.data.error && err.response.data.error == 'captchaText') {
						this.captchaError = true;
						this.$refs.form.resetCaptcha();
						this.generateCaptcha();
					} else if (err.response.data && err.response.data.publicErrorMessage) {
						this.resultState = RESULTSTATES.ERROR;
						this.publicErrorMessage = err.response.data.publicErrorMessage;
					}
				} else {
					this.resultState = RESULTSTATES.ERROR;
				}
			} finally {
				this.sending = false;
			}
		},
		async getSettlements(zipCode) {
			try {
				const response = await postcodesApi.getSettlements(zipCode);
				this.settlements = response.data.map(settlement => settlement.settlement);
			} catch (err) {
				this.resultState = RESULTSTATES.ERROR;
			}
		},
		async generateCaptcha() {
			try {
				const response = await productionToolContractingApi.generateCaptcha();
				this.captcha = response.data;
			} catch (err) {
				this.resultState = RESULTSTATES.ERROR;
			}
		},
		async init() {
			try {
				const response = await productionToolContractingApi.init();
				this.yearlyIncome = response.data.yearlyIncome;
				this.instrument = response.data.instrument;
				this.captcha = response.data.captcha;
			} catch (err) {
				this.resultState = RESULTSTATES.ERROR;
			} finally {
				this.loading = false;
			}
		}
	},
	created() {
		this.init();
	}
};
</script>

<style lang="scss">
@import '@ui-common/sf-style-utils/lib/helpers/_colors.scss';
@import '@ui-common/sf-style-utils/lib/helpers/_queries.scss';

.production-tool-contracting-feedback {
	padding-bottom: 32px;
	padding-left: 24px;
	padding-right: 24px;
	padding-top: 32px;

	@include media('>=tablet') {
		padding-bottom: 48px;
		padding-left: 84px;
		padding-right: 84px;
		padding-top: 48px;
	}

	@include media('>=desktop') {
		padding-bottom: 64px;
		padding-left: 192px;
		padding-right: 192px;
		padding-top: 64px;
	}
}
</style>
